import styled from "styled-components";
import { NavLink } from 'react-router-dom';

export const MainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  gap: 80px;
  
  @media screen and (max-width: 970px) {
    height: 100%;
    flex-direction: column;
    .pricing-component {
    }
  }
`;

export const JSXMainContainer = styled.div`
  border-radius: 12px;
  padding: 5px;
  padding-bottom: 15px;
  width: 20rem;
  min-height: 38rem;
  height: max-content;
  background-color: rgb(46, 46, 46);
  display: flex;
  flex-direction: column;
  color: #ffffff;
  box-shadow: 0 8px 14px -6px ${(props) => props.shadow};
  transition: 0.4s ease-in-out;
  
  &:hover {
    //box-shadow: 0 2px 26px -6px #a0c5fa;
    transform: scale(1.005);
     background-color: ${({ theme }) => theme?.color?.spotifyLightGrey || '#3e3e3e'};
  }
`;

export const Header = styled.div`
  border-radius: 15px;
  margin: 0.6rem;
  height: 4rem;
  background-color: #282828;
//   background-image: ${(props) => props.background};
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: larger;
  font-weight: 600;
  color: #ffffff;
`;

export const PricingContainer = styled.div`
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 1.5rem;
`;

export const PriceContainer = styled.div`
  display: flex;
`;

export const CurrencyContainer = styled.div`
  margin-top: 0.5rem;
  margin-right: 0.2rem;
  color: #b3b3b3;
`;

export const Price = styled.div`
  span {
    font-size: 3rem;
    color: #ffffff;
  }
`;

export const Duration = styled.div`
  margin-top: 2rem;
  color: #b3b3b3;
`;

export const SubTitle = styled.div`
  text-transform: uppercase;
  text-align: center;
  margin: 0.4rem 0 1.3rem 0;
  
  h4 {
    margin: 0;
    ${(props) => props.isPremium ? `  background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;` : `color:rgb(228, 228, 228)`};
  }
`;

export const PriceText = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  text-align: center;
  font-weight: 500;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #b3b3b3;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
`;

export const Button = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  border-radius: 0.4rem;
  border: 0.1rem solid #179544;
  width: 90%;
  height: 3.5rem;
  background-color: transparent;
  font-size: 1.2rem;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  text-decoration: none;
  color: #ffffff;
  
  &:hover {
    background-color: #179544;
    color: #121212;
  }
`;

export const DataContainer = styled.div`
  padding: 0 15px 0 0; // Zmniejszono padding-left do 0, zachowano padding-right
  margin-left: 11%; // Przesunięcie w prawo o 5% (połowa różnicy od width: 90% przycisku)
  ul {
    list-style-type: none;
    margin-left: -13px;
    
    li {
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      color: #ffffff;
      
      .true {
        color: #179544;
        font-size: 1rem;
      }
      
      .false {
        color: #f54343;
      }
      
      svg {
        margin-right: 0.5rem;
        font-size: 0.8rem;
      }
      
      margin-bottom: 1rem;
    }
  }
`;

export const CompanyInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px auto 0 auto;
  padding: 25px;
  background-color: #1e1e1e;
  border: 1px solid #444;
  border-radius: 12px;
  width: 45rem; 
  max-width: 90%;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);

  @media screen and (max-width: 970px) {
    width: 20rem;
    max-width: 90%;
  }
`;

export const InfoText = styled.p`
  color: #e0e0e0;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 20px;
  max-width: 800px;

  strong {
    font-weight: 700;
    color: #1DB954;
  }
`;

export const InfoImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
`;

export const FooterNote = styled(NavLink)`
  display: inline;
  font-size: inherit;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: inherit;
  }
`;